import { inject, Injectable } from '@angular/core';
import { CourseGTMService } from '@uc/web/core';
import { Product, ProductEnum } from '@uc/web/shared/data-models';

@Injectable({ providedIn: 'root' })
export class CourseAnalyticsService {
	private _courseGTMSrv = inject(CourseGTMService);

	/*
	 * GTM event - User views the screen for a course profile
	 */
	executeGTMEvents(
		uniId: number,
		uniName: string,
		position: number | null,
		courseId: number,
		courseName: string,
		product: Product,
	) {
		const ugSearchOrderPosition =
			product === ProductEnum.Undergraduate ? position : null;
		const cleSearchOrderPosition = product === ProductEnum.Clearing ? position : null;

		// The condition is here only to satisfy typescript
		if (!uniId || !courseId || !courseName || !uniName) return;

		// GTM event - User views the screen for a course profile
		this._courseGTMSrv.courseProfileView(
			uniId,
			uniName,
			courseName,
			courseId,
			ugSearchOrderPosition,
			cleSearchOrderPosition,
			product,
		);
		this._courseGTMSrv.courseImpression(
			uniId,
			uniName,
			courseName,
			courseId,
			ugSearchOrderPosition,
			cleSearchOrderPosition,
			product,
		);
	}
}
